module.exports = __webpack_public_path__ + "static/img/283523-1-GEKBQ.a59a589.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/283523-1-GEKBQ.png
// module id = 4Kt3
// module chunks = 0